import React, { useEffect, useState } from "react";
import { useAtom, useAtomValue } from "jotai";
import { selectedValuesAtom, shouldGenerateSampaPhonemeAtom } from "atoms";
import { useTTS } from "shared/hooks/useTTS";
import ipaSampaMap from "./components/ipa-sampa-map.json";
import PronunciationTabTemplate from "./components/PronunciationTabTemplate";

interface PronunciationMenuXSampaProps {
  selectedWord: string;
  userPhoneme: string;
  setPhoneme: React.Dispatch<React.SetStateAction<string>>;
}

export default function PronunciationMenuXSampa({
  selectedWord,
  userPhoneme,
  setPhoneme,
}: PronunciationMenuXSampaProps): JSX.Element {
  const selectedValues = useAtomValue(selectedValuesAtom);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    selectedValues.selectedLanguage
  );
  const [shouldGenerateSampaPhoneme, setShouldGenerateSampaPhoneme] = useAtom(
    shouldGenerateSampaPhonemeAtom
  );
  const { getPhonemeText } = useTTS();

  const handleRegenerateClick = async () => {
    const input = `<speak><lang language="${selectedLanguage}">${selectedWord}</lang></speak>`;
    try {
      const ipaPhoneme = await getPhonemeText(input);
      let sampaPhoneme = "";
      const ipaArray = [...ipaPhoneme];
      ipaArray.forEach((input) => {
        const map = ipaSampaMap.find(
          (y: { ipa: string; sampa: string }) => y.ipa === input
        );
        if (map) sampaPhoneme += map.sampa;
      });
      setPhoneme(sampaPhoneme);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  useEffect(() => {
    async function regenerateOnLoad() {
      await handleRegenerateClick();
    }
    if (shouldGenerateSampaPhoneme) {
      if (selectedWord) regenerateOnLoad();
      setShouldGenerateSampaPhoneme(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldGenerateSampaPhoneme]);

  const handleLanguageChange = (newLanguage: string) => {
    setSelectedLanguage(newLanguage);
  };

  return (
    <PronunciationTabTemplate
      isIPA={false}
      selectedWord={selectedWord}
      userPhoneme={userPhoneme}
      setPhoneme={setPhoneme}
      selectedLanguage={selectedLanguage}
      handleLanguageChange={handleLanguageChange}
      handleRegenerateClick={handleRegenerateClick}
    />
  );
}
